/**
 * Whether "Reset to original" has a file to go back to (PREC-4392).
 *
 * Mirrors the API's `resetToOriginalFile` (`apps/api/src/csv-enrichment/utils/reset-to-original.util.ts`):
 * only a delivered file links its original, and the list payload's `originalCsvEnrichment` include
 * is null once that original is deleted. An uploaded file is altered in place and keeps nothing,
 * so for it the button is left out rather than offered and refused.
 */
export function canResetToOriginalFile(csvEnrichment: {
	altered?: boolean;
	originalCsvEnrichment?: { id: number } | null;
}): boolean {
	return !!csvEnrichment.altered && !!csvEnrichment.originalCsvEnrichment;
}
